import {SectionIntro, Box} from '@primer/react-brand/esm'
import type {SupportSectionProps} from './types'
import {renderWithoutParagraphs} from '../../../utils'
import {SupportIconCards} from './SupportIconCards'
import {SupportImageCards} from './SupportImageCards'
import {SupportPillars} from './SupportPillars'
import {SupportStats} from './SupportStats'
import {SupportGrid} from './SupportGrid'

export const SupportSection = ({
  supportHeading,
  supportLabel,
  supportDescription,
  supportDetails,
  supportIconCards,
  supportPillars,
  supportImageCards,
  supportStats,
}: SupportSectionProps) => {
  const hasDetails = Boolean(
    (supportDetails === 'Icon Cards' && supportIconCards?.length) ||
    (supportDetails === 'Image Cards' && supportImageCards?.length) ||
    (supportDetails === 'Pillars' && supportPillars?.length) ||
    (supportDetails === 'Statistics' && supportStats?.length),
  )

  if (!supportHeading && !supportDescription && !supportLabel && !hasDetails) {
    return null
  }

  return (
    <Box>
      <Box
        paddingBlockEnd={{
          narrow: 'spacious',
          regular: 64,
        }}
        paddingBlockStart={{
          narrow: 'spacious',
          regular: 64,
        }}
      >
        <SectionIntro align="center" fullWidth>
          {supportLabel && <SectionIntro.Label>{supportLabel}</SectionIntro.Label>}
          {supportHeading && (
            <SectionIntro.Heading size="3">{renderWithoutParagraphs(supportHeading)}</SectionIntro.Heading>
          )}
          {supportDescription && (
            <SectionIntro.Description>{renderWithoutParagraphs(supportDescription)}</SectionIntro.Description>
          )}
        </SectionIntro>
      </Box>
      {hasDetails && (
        <Box
          data-testid="support-details-section"
          borderBlockEndWidth="thin"
          borderBlockStartWidth="thin"
          borderStyle="solid"
          borderColor="muted"
        >
          <SupportGrid>
            {supportDetails === 'Icon Cards' && supportIconCards && <SupportIconCards items={supportIconCards} />}
            {supportDetails === 'Image Cards' && supportImageCards && <SupportImageCards items={supportImageCards} />}
            {supportDetails === 'Pillars' && supportPillars && <SupportPillars items={supportPillars} />}
            {supportDetails === 'Statistics' && supportStats && <SupportStats items={supportStats} />}
          </SupportGrid>
        </Box>
      )}
    </Box>
  )
}
